import React from 'react';

const AssignOwnerContext = React.createContext();

const MODAL_OPEN = 'MODAL_OPEN';
const MODAL_CLOSED = 'MODAL_CLOSED';
const AGENT_SELECTED = 'AGENT_SELECTED';

export const openAssignOwnerModal = ({ journeyIds }) => ({
  type: MODAL_OPEN,
  payload: { journeyIds },
});

export const closeAssignOwnerModal = () => ({
  type: MODAL_CLOSED,
  payload: {},
});

export const selectAgentAssignOwnerModal = ({ agent }) => ({
  type: AGENT_SELECTED,
  payload: { agent },
});

function ownerReducer(state, action) {
  switch (action.type) {
    case MODAL_OPEN: {
      return { ...state, modalStatus: 'open', journeyIds: action?.payload?.journeyIds };
    }
    case MODAL_CLOSED: {
      return { ...state, modalStatus: 'closed', journeyIds: [] };
    }
    case AGENT_SELECTED: {
      return { ...state, agent: action?.payload?.agent };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function AssignOwnerProvider({ children }) {
  const [state, dispatch] = React.useReducer(ownerReducer, {
    modalStatus: 'closed',
    agentId: null,
    journeyIds: [],
  });
  return (
    <AssignOwnerContext.Provider value={{ state, dispatch }}>
      {children}
    </AssignOwnerContext.Provider>
  );
}

function useAssignOwnerContext() {
  const context = React.useContext(AssignOwnerContext);
  if (context === undefined) {
    throw new Error('useAssignOwnerContext must be used within a AssignOwnerProvider');
  }
  return context;
}

export { AssignOwnerProvider, useAssignOwnerContext };
